import React from "react";
import { useTranslation } from "react-i18next";
import { Edit2, Trash2 } from "lucide-react";
import { Button } from "@core/index";

interface EditButtonsProps {
  onEdit: () => void;
  onDelete: () => void;
  className?: string;
}

export const EditButtons: React.FC<EditButtonsProps> = ({
  onEdit,
  onDelete,
  className = "",
}) => {
  return (
    <div
      className={`flex items-center gap-2 w-full sm:w-auto justify-end ${className}`}
    >
      <Button
        onClick={onEdit}
        size="md"
        rounded="lg"
        bgColor="bg-purple-100 hover:bg-purple-200 dark:bg-purple-700 dark:hover:bg-purple-800"
        textColor="text-purple-500 hover:text-purple-600 dark:text-purple-400 dark:hover:text-purple-300"
      >
        <Edit2 size={16} />
      </Button>
      <Button
        onClick={onDelete}
        size="md"
        rounded="lg"
        bgColor="bg-red-100 hover:bg-red-200 dark:bg-red-700 dark:hover:bg-red-800"
        textColor="text-red-500 hover:text-red-600 dark:text-red-400 dark:hover:text-red-300"
      >
        <Trash2 size={16} />
      </Button>
    </div>
  );
};
